import axios from "axios";
import { v4 as uuidv4 } from "uuid";

class ApiService {

  constructor() {
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    this.apiBaseURL = isLocalhost
      ? "http://127.0.0.1:8080"   // local backend
      : window._env_.REACT_APP_BACKEND_API_BASE_URL; // env-based backend

    this.axiosInstance = axios.create({
      baseURL: this.apiBaseURL,
    });
  }



  /**
   * get releases by date range(optional)
   * (null,null) to fetch all releases
   */
getAllReleasesByDateRange = async (startDate, endDate, accessToken) => {
  if (!accessToken) throw new Error("Missing access token");

  try {
    const response = await this.axiosInstance.get(
      `/release-service/v1/releases`,
      {
        params: { startDate, endDate },
        headers: {
          requestid: uuidv4(),
          authorization: `Bearer ${accessToken}`,
          timestamp: new Date().toISOString(),
        },
      }
    );

    const data = response?.data ?? null;

    if (!data) {
      console.warn("No body in response", response);
      return [];
    }

    const releases = Array.isArray(data.releases)
      ? data.releases
      : Array.isArray(data)
      ? data
      : [];

   
   releases.sort(
  (a, b) => new Date(a.CreationTimestamp) - new Date(b.CreationTimestamp)
);

    console.log("ApiService.getAllReleasesByDateRange -> releases:", releases);
    return releases;
  } catch (error) {
    console.error("Error fetching releases by date range:", error);
    throw error;
  }
};


  
  


  


 /**
   * get releases by release id
   */
 getAllReleasesByReleaseId = async (releaseId, accessToken) => {
  if (!accessToken) throw new Error("Missing access token");

  try {
    const response = await this.axiosInstance.get(`/release-service/v1/release`, {
      params: { releaseId },
      headers: {
        requestid: uuidv4(),
        authorization: `Bearer ${accessToken}`,
        timestamp: new Date().toISOString(),
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching releases by release id:", error);
    throw error;
  }
};







 /**
   * get pdf report by report id
   */
getReportFileByReleaseId = async (releaseId, accessToken) => {

    if (!accessToken) throw new Error("Missing access token");



  try {
    const response = await this.axiosInstance.get(`/release-service/v1/release/report`, {
      responseType: "blob", 
      params: { releaseId },
      headers: {
        requestid: uuidv4(),
        authorization: `Bearer ${accessToken}`,
        timestamp: new Date().toISOString(),
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching PDF report file:", error);
    throw error;
  }
};











getHeatmapImageByReleaseId = async (releaseId, accessToken) => {
 if (!accessToken) throw new Error("Missing access token");
  try {
    const response = await this.axiosInstance.get(`/release-service/v1/release/heatmap`, {
      responseType: 'arraybuffer', // key: treat response as binary
      params: {
        releaseId: releaseId,
      },
      headers: {
        requestid: uuidv4(),
        authorization: `Bearer ${accessToken}`,
        timestamp: new Date().toISOString(),
      },
    });

    const contentType = response.headers["content-type"];
    const base64 = btoa(
      new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
    return `data:${contentType};base64,${base64}`;
  } catch (error) {
    console.error("Error fetching heatmap image:", error);
    throw error;
  }
};






  


  
}

const apiService = new ApiService();

export default apiService;
